import {Component, OnDestroy, OnInit} from '@angular/core';
import {DroitService} from './droit.service';
import {HebergementBnbaccessPopupService} from '../hebergement-bnbaccess-popup.service';
import {NgbActiveModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {ActivatedRoute} from '@angular/router';
import {DroitBnbaccess, HebergementBnbaccess} from '../hebergement-bnbaccess.model';
import {JhiLanguageService} from 'ng-jhipster';
import {isValid} from 'date-fns';
import {parseFromTimeZone} from 'date-fns-timezone';

@Component({
    selector: 'jhi-droit',
    templateUrl: './droit.component.html',
    styleUrls: ['./droit.css']
})
export class DroitComponent implements OnInit {

    droitsGestionnaires: DroitBnbaccess[];
    droitsVoyageurs: DroitBnbaccess[];
    droitEnModification: DroitBnbaccess;
    backupDroit: DroitBnbaccess;
    nouveauDroitVoyageur: DroitBnbaccess = new DroitBnbaccess();
    nouveauDroitGestionnaire: DroitBnbaccess = new DroitBnbaccess();
    hebergement: HebergementBnbaccess;
    typesOuvertures = ['PREMIERE OUVERTURE', 'A DEJA ETE OUVERTE'];
    saveInProgress = false;

    constructor(private droitService: DroitService, public activeModal: NgbActiveModal, private jhiLanguageService: JhiLanguageService,
    ) {
        this.jhiLanguageService.setLocations(['hebergement']);
    }

    ngOnInit() {
        this.refreshGestionnaires();
        this.refreshVoyageurs();
    }

    private refreshVoyageurs() {
        this.droitService.queryDroits(this.hebergement, 'VOYAGEUR')
            .subscribe((droitsVoyageurs) => this.droitsVoyageurs = droitsVoyageurs);
    }

    private refreshGestionnaires() {
        this.droitService.queryDroits(this.hebergement, 'GESTIONNAIRE')
            .subscribe((droitsGestionnaires) => this.droitsGestionnaires = droitsGestionnaires);
    }

    close() {
        this.activeModal.dismiss('close');
    }

    confirmRemoveDroit(droit: DroitBnbaccess) {
        if (window.confirm('Supprimer le droit ?')) {
            this.droitService.deleteDroit(this.hebergement, droit).subscribe(() => {
                this.refreshGestionnaires();
                this.refreshVoyageurs();
            });
        }
    }

    editDroit(droit: any) {
        this.droitEnModification = droit;
        this.backupDroit = {...droit};
    }

    parsingDate(event): Date {
        return new Date(event);

    }

    saveDroitGestionnaire(droit: DroitBnbaccess) {
        droit.typeDroit = 'GESTIONNAIRE';
        this.droitService.createDroit(this.hebergement, droit).subscribe(() => {
            this.nouveauDroitGestionnaire = new DroitBnbaccess();
            this.refreshGestionnaires();
        });
    }

    saveDroitVoyageur(droit: DroitBnbaccess) {
        droit.typeDroit = 'VOYAGEUR';
        droit.dateDeb = this.getUtcDate(droit.dateDeb);
        droit.dateFin = this.getUtcDate(droit.dateFin);
        this.droitService.createDroit(this.hebergement, droit).subscribe(() => {
            this.nouveauDroitVoyageur = new DroitBnbaccess();
            this.refreshVoyageurs();
        });
    }

    updateDroit(droit: DroitBnbaccess) {
        if (droit.id && !this.saveInProgress) {
            this.saveInProgress = true;
            const droitToSave = {...droit};
            if (droit.dateFin !== this.backupDroit.dateFin) {
                droitToSave.dateFin = this.getUtcDate(droit.dateFin);
            }
            if (droit.dateDeb !== this.backupDroit.dateDeb) {
                droitToSave.dateDeb = this.getUtcDate(droit.dateDeb);
            }
            this.droitService.updateDroit(this.hebergement, droitToSave).subscribe((savedDroit) => {
                Object.assign(droit, savedDroit);
                this.saveInProgress = false;
                this.droitEnModification = null;
            }, () => {
                this.saveInProgress = false;
                this.droitEnModification = null;
            });
        }
    }

    cancelEditDroit(droit: DroitBnbaccess) {
        Object.assign(droit, this.backupDroit);
        this.droitEnModification = null;
    }

    getUtcDate = (date: Date | string) => {
        date = typeof date === 'string' ? new Date(date) : date;

        return isValid(date)
            ? parseFromTimeZone(date.toISOString(), {timeZone: 'Etc/UTC'})
            : date;
    }
}

@Component({
    selector: 'jhi-droit-popup',
    template: ''
})
export class DroitPopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private hebergementPopupService: HebergementBnbaccessPopupService
    ) {
    }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            this.modalRef = this.hebergementPopupService
                .open(DroitComponent, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/hebergement/droit/droit.component.ts